import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {DamageReport} from '../../../models/models';
import {LoginService} from '../../../services/login.service';
import {CheckService} from '../../../services/check.service';
import {DamageAdministrationService} from '../../../services/damage-administration.service';
import {GridComponent, RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import {ClickEventArgs} from '@syncfusion/ej2-angular-navigations';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'app-damage-administration-overview',
  templateUrl: './damage-administration-overview.component.html',
  styleUrls: ['./damage-administration-overview.component.css']
})
export class DamageAdministrationOverviewComponent implements OnInit {

  @ViewChild('damageAdministrationOverviewGrid', {static: true}) private damageAdministrationOverviewGrid: GridComponent;

  public locale: string;
  public dataSource: DamageReport[] = [];
  public formatOptions: any;

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private damageAdministrationService: DamageAdministrationService,
    private router: Router,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(12);
    this.loadDataSource();
  }

  loadDataSource() {
    const workshopList = this.damageAdministrationService.getReceivers();
    const carTypeList = this.damageAdministrationService.getCarTypes();
    const jobTypeList = this.damageAdministrationService.getJobTypes();
    const employeeList = this.damageAdministrationService.getEmployees();
    const damageReportList = this.damageAdministrationService.getDamageReportsInsertedByCotra();
    const carBrandList = this.damageAdministrationService.getCarBrands();
    forkJoin([workshopList, carTypeList, jobTypeList, employeeList, damageReportList, carBrandList]).subscribe((result: any) => {
      result[4].forEach(d => {
        let lookup;
        lookup = result[1].Obj.find(c => c.CarTypeId === d.Type);
        d.CarTypeDisplayName = lookup !== undefined ? lookup.CarTypeName : '';
        lookup = result[2].Obj.find(j => j.JobTypeId === d.JobType);
        d.JobTypeDisplayName = lookup !== undefined ? lookup.JobTypeName : '';
        lookup = result[0].Obj.find(r => r.ReceiverId === d.Receiver);
        d.ReceiverDisplayName = lookup !== undefined ? lookup.ReceiverName : '';
        lookup = result[0].Obj.find(r => r.ReceiverId === d.Workshop);
        d.WorkshopDisplayName = lookup !== undefined ? lookup.ReceiverName : '';
        lookup = result[3].Obj.find(r => r.UniqueId === d.CausedBy);
        d.CausedByDisplayName = lookup !== undefined ? lookup.LastName : '';
        lookup = result[5].Obj.find(b => b.CarBrandId === d.Brand);
        d.BrandDisplayName = lookup !== undefined ? lookup.CarBrandName : '';
      });
      this.dataSource = result[4];
      this.initGrid();
    });
  }

  initGrid() {
    this.damageAdministrationOverviewGrid.allowExcelExport = true;
    this.damageAdministrationOverviewGrid.allowPdfExport = true;
    this.damageAdministrationOverviewGrid.allowPaging = true;
    this.damageAdministrationOverviewGrid.pageSettings = {pageCount: 5, pageSize: 20};
    this.damageAdministrationOverviewGrid.toolbar = ['ExcelExport', 'PdfExport', 'Print', 'Search'];
    this.damageAdministrationOverviewGrid.editSettings = {allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal'};
  }

  rowDataBound(args: RowDataBoundEventArgs) {
    // @ts-ignore
    if (args.data.CheckDocStateDone) {
      args.row.classList.add('greenLine');
      // @ts-ignore
    } else if (args.data.CheckDocStateRelease) {
      args.row.classList.add('blueLine');
      // @ts-ignore
    } else if (args.data.CheckDocStateIncomplete) {
      args.row.classList.add('redLine');
    }
  }

  openDamageAdministrationRecord($event: MouseEvent) {
    // @ts-ignore
    this.router.navigate(['/damageAdministrationRecord', $event.rowData.DocNum]);
  }

  toolbarClick($event: ClickEventArgs) {
    if ($event.item.id === 'damageAdministrationOverviewGrid_excelexport') {
      this.damageAdministrationOverviewGrid.excelExport();
    }
    if ($event.item.id === 'damageAdministrationOverviewGrid_pdfexport') {
      this.damageAdministrationOverviewGrid.pdfExport();
    }
  }
}
